import { BeVoucherCondition } from 'types/voucher';
import { formatCurrency } from 'utils/FormatNumber';
import { LineConditionProps } from './LineCondition';
import { ListConditionProps } from './ListCondition';

export const adaptListCondition = (voucherCondition?: BeVoucherCondition['conditionMessages']): ListConditionProps => {
  const defaultValue = {
    conditions: [],
    isSubCondition: false,
  };

  if (!voucherCondition) return defaultValue;

  try {
    return {
      conditions: adaptLineCondition(voucherCondition),
      isSubCondition: false,
    };
  } catch (e) {
    return defaultValue;
  }
};

const adaptKcbLicenseContent = (message: string): string => {
  const urlMatch = message.match(/https?:\/\/\S+\s*$/);
  if (!urlMatch) return message;

  const url = urlMatch[0].trim();
  const text = message.slice(0, message.length - urlMatch[0].length).trim();
  const anchor = `<a href="${url}" style="text-decoration:underline">tại đây</a>`;

  return text.endsWith('tại đây') ? `${text.slice(0, text.length - 'tại đây'.length)}${anchor}` : `${text} ${anchor}`;
};

const adaptLineCondition = (voucherCondition: BeVoucherCondition['conditionMessages'], defaultDisabled?: boolean): LineConditionProps[] => {
  if (!voucherCondition) return [];

  return voucherCondition.map((condition) => {
    let prefix = 'Đã thêm vào giỏ';
    let current = (condition.current || 0).toString();
    let total = (condition.target || 0).toString();
    let hideProgressBar = false;
    let disabledChild = false;
    let percent = 0;

    const hasChildren = condition.subs && condition.subs.length > 0;
    const hasChildIsOR = condition.subs && condition.subs.some((o) => o.conditionType === 'OR');
    const hasChildIsAND = condition.subs && condition.subs.some((o) => o.conditionType === 'AND');
    const hasChildIsDone = condition.subs && condition.subs.some((o) => o.percentageCondition === 100);

    let percentOfChildren = 0;

    switch (condition.voucherConditionType) {
      case 'ORDER_VALUE': {
        if (condition.message.includes('vnđ')) {
          current = formatCurrency(current);
          total = formatCurrency(total);
        }
        break;
      }
      default:
        break;
    }

    let progressContent = `${prefix} ${current}/${total}`;

    if (condition.percentageCondition) {
      percent = condition.percentageCondition;
    }

    if (hasChildren) {
      prefix = 'Đã thoả';
      progressContent = condition.message;

      if (hasChildIsOR) {
        hideProgressBar = true;
        // get max of children
        percentOfChildren = condition.subs.reduce((max, o) => {
          return o.percentageCondition > max ? o.percentageCondition : max;
        }, 0);
        percent = percentOfChildren;

        if (hasChildIsDone) {
          disabledChild = true;
        }
      }

      if (hasChildIsAND) {
        // total of children
        percentOfChildren = condition.subs.reduce((sum, o) => {
          return sum + o.percentageCondition;
        }, 0);
        percent = percentOfChildren / condition.subs.length;
      }
    }

    let content = condition.message;

    switch (condition.voucherConditionType) {
      case 'PAYMENT_METHOD': {
        progressContent = 'Áp dụng cho hình thức thanh toán';
        break;
      }
      case 'KCB_LICENSE': {
        content = adaptKcbLicenseContent(condition.message);
        break;
      }
      default:
        break;
    }

    return {
      progressContent: condition.progressMessage || progressContent,
      hideProgressBar,
      content,
      percent,
      isOR: condition.conditionType === 'OR',
      subConditions: adaptLineCondition(condition.subs, disabledChild),
      isSubCondition: condition.conditionType === 'OR',
      disabled: !condition.percentageCondition && defaultDisabled,
    };
  });
};

